import { retryConstants, retrynameSpace } from "../constants/cardRequests.constants";

const initialState = {
    loading: false,
    success: false,
    request: null,
    response: null,
    error: null,
};

export const retryCardRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case retryConstants[`POST_${retrynameSpace}_REQUEST`]:
            return {
                ...state,
                loading: true,
                request: action.request,
            };
        case retryConstants[`POST_${retrynameSpace}_SUCCESS`]:
            return {
                ...state,
                loading: false,
                success: true,
                response: action.response,
                error: null,
            };
        case retryConstants[`POST_${retrynameSpace}_FAILURE`]:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.error,
            };
        case retryConstants[`POST_${retrynameSpace}_RESET`]:
            return {
                loading: false,
                success: false,
                request: null,
                response: null,
                error: null,
            };
        default:
            return state;
    }
};
